import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingCards() {
  return <section className="py-6 md:py-10 px-4 max-w-5xl mx-auto" id="pricing" data-id="element-284">
      <FadeIn data-id="element-285">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-5 md:mb-8 tracking-tight text-[#1f1b16]" data-id="element-286">
          ELEGÍ TU SISTEMA
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto items-stretch" data-id="element-287">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-288">
          <div className="bg-[#faf7f2] border border-[#e7dfce] rounded-2xl p-5 md:p-7 h-full flex flex-col relative hover:border-[#7c3aed]/50 transition-colors shadow-sm" data-id="element-289">
            <div className="mb-3" data-id="element-290">
              <h3 className="text-lg md:text-xl font-black text-[#1f1b16] flex items-center gap-2 mb-1" data-id="element-291">
                <span className="text-xl md:text-2xl" data-id="element-292">📘</span> BOTIQUÍN
                VIBRACIONAL PRO
              </h3>
              <p className="text-[#6b6358] font-bold text-xs md:text-sm" data-id="element-293">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-4 pb-4 border-b border-[#e7dfce]" data-id="element-294">
              <div className="text-[#ef4444] line-through text-sm font-bold" data-id="element-295">
                $150.000
              </div>
              <div className="text-3xl md:text-4xl font-black text-[#1f1b16] flex items-baseline gap-2" data-id="element-296">
                $19.990{' '}
                <span className="text-base text-[#6b6358] font-bold" data-id="element-297">ARS</span>
              </div>
            </div>

            <ul className="space-y-2 mb-5 flex-grow" data-id="element-298">
              <li className="flex items-start gap-2.5" data-id="element-299">
                <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-300">
                  <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-301" />
                </div>
                <span className="text-sm text-[#1f1b16] font-bold" data-id="element-302">
                  6 Tomos completos (360 páginas)
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-303">
                <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-304">
                  <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-305" />
                </div>
                <span className="text-sm text-[#1f1b16] font-bold" data-id="element-306">
                  6 Bonos siempre incluidos (240 páginas)
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-307">
                <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-308">
                  <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-309" />
                </div>
                <span className="text-sm text-[#1f1b16] font-bold" data-id="element-310">
                  Más de 600 páginas de contenido aplicable
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-311">
                <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-312">
                  <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-313" />
                </div>
                <span className="text-sm text-[#1f1b16] font-bold" data-id="element-314">
                  Acceso inmediato por correo
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-315">
                <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-316">
                  <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-317" />
                </div>
                <span className="text-sm text-[#1f1b16] font-bold" data-id="element-318">
                  Actualizaciones de por vida
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-319">
                <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-320">
                  <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-321" />
                </div>
                <span className="text-sm text-[#1f1b16] font-bold" data-id="element-322">
                  Funciona con apps gratuitas (Spotify, YouTube)
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44193380892708:1" className="w-full block text-center py-3 px-4 rounded-xl font-black text-base bg-[#0f0d09] hover:bg-[#1f1b16] text-[#7c3aed] transition-colors border border-[#1f1b16]" data-id="element-323">
              → QUIERO MI BOTIQUÍN VIBRACIONAL PRO
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-324">
          <div className="relative h-full" data-id="element-325">
            <div className="absolute inset-0 bg-[#7c3aed]/20 blur-3xl rounded-[3rem] animate-pulse" data-id="element-326"></div>
            <div className="bg-[#faf7f2] border-2 border-[#7c3aed] rounded-2xl p-5 md:p-7 h-full flex flex-col relative shadow-[0_20px_50px_rgba(124,58,237,0.15)] z-10" data-id="element-327">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#7c3aed] to-[#a78bfa] text-[#0f0d09] font-black px-4 py-1 rounded-full text-xs flex items-center gap-1.5 whitespace-nowrap shadow-md" data-id="element-328">
                <Star className="w-3.5 h-3.5" fill="currentColor" data-id="element-329" /> MÁS ELEGIDO
              </div>

              <div className="mb-3 mt-3" data-id="element-330">
                <h3 className="text-lg md:text-xl font-black text-[#1f1b16] flex items-center gap-2 mb-1" data-id="element-331">
                  <span className="text-2xl" data-id="element-332">🏆</span> BOTIQUÍN VIBRACIONAL PRO
                  + LABORATORIO PRO
                </h3>
                <p className="text-[#5b21b6] font-bold text-xs md:text-sm" data-id="element-333">
                  6 Tomos + 6 Bonos + El Sistema Avanzado de Bio-Hacking Sonoro
                </p>
              </div>

              <div className="mb-4 pb-4 border-b border-[#e7dfce]" data-id="element-334">
                <div className="text-[#ef4444] line-through text-sm font-bold" data-id="element-335">
                  $220.000
                </div>
                <div className="text-3xl md:text-4xl font-black text-[#1f1b16] flex items-baseline gap-2" data-id="element-336">
                  $27.990{' '}
                  <span className="text-base text-[#6b6358] font-bold" data-id="element-337">
                    ARS
                  </span>
                </div>
              </div>

              <ul className="space-y-2 mb-5 flex-grow" data-id="element-338">
                <li className="flex items-start gap-2.5" data-id="element-339">
                  <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-340">
                    <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-341" />
                  </div>
                  <span className="text-sm text-[#1f1b16] font-bold" data-id="element-342">
                    Todo lo del Botiquín Vibracional Pro
                  </span>
                </li>
                <li className="flex items-start gap-2.5 bg-[#7c3aed]/10 p-2 rounded-xl border border-[#7c3aed]/30 -mx-1" data-id="element-343">
                  <div className="bg-[#7c3aed] p-1 rounded-full shrink-0 mt-0.5" data-id="element-344">
                    <Check className="text-[#0f0d09]" size={14} strokeWidth={4} data-id="element-345" />
                  </div>
                  <span className="text-sm text-[#5b21b6] font-black" data-id="element-346">
                    Laboratorio Vibracional Pro (60 páginas exclusivas)
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-347">
                  <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-348">
                    <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-349" />
                  </div>
                  <span className="text-sm text-[#1f1b16] font-bold" data-id="element-350">
                    Sistema de Micro-Dosis Sonoras (14 min por día)
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-351">
                  <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-352">
                    <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-353" />
                  </div>
                  <span className="text-sm text-[#1f1b16] font-bold" data-id="element-354">
                    15 Stacks de Frecuencias Avanzados
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-355">
                  <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-356">
                    <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-357" />
                  </div>
                  <span className="text-sm text-[#1f1b16] font-bold" data-id="element-358">
                    Reprogramación Subconsciente con Theta
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-359">
                  <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-360">
                    <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-361" />
                  </div>
                  <span className="text-sm text-[#1f1b16] font-bold" data-id="element-362">
                    Bio-Hacking Metabólico con Sonido
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-363">
                  <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-364">
                    <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-365" />
                  </div>
                  <span className="text-sm text-[#1f1b16] font-bold" data-id="element-366">
                    Plan Acelerado de 90 Días con checkpoints de 72 hs
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-367">
                  <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-368">
                    <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-369" />
                  </div>
                  <span className="text-sm text-[#1f1b16] font-bold" data-id="element-370">
                    Autohipnosis Sonora sin experiencia previa
                  </span>
                </li>
                <li className="flex items-start gap-2.5" data-id="element-371">
                  <div className="bg-[#7c3aed]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-372">
                    <Check className="text-[#5b21b6]" size={14} strokeWidth={3} data-id="element-373" />
                  </div>
                  <span className="text-sm text-[#1f1b16] font-bold" data-id="element-374">
                    Matrix de 25 Audio-Fórmulas para situaciones reales
                  </span>
                </li>
              </ul>

              <motion.a whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} href="https://tumanualdigital.com/cart/44193381122084:1" className="w-full block text-center py-3 px-4 rounded-xl font-black text-base bg-[#7c3aed] hover:bg-[#a78bfa] text-[#0f0d09] transition-colors shadow-[0_10px_30px_rgba(124,58,237,0.3)]" data-id="element-375">
                → QUIERO EL BOTIQUÍN + LABORATORIO PRO
              </motion.a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}